import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { concatMap, first } from 'rxjs/operators';

import { coreSelectors } from '../store/core.selectors';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private store: Store
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select(coreSelectors.accessToken).pipe(
      first(),
      concatMap(token => {
        if (token) {
          const requestWithToken = request.clone({ setHeaders: { 'x-token': token } });
          return next.handle(requestWithToken);
        } else {
          return next.handle(request);
        }
      })
    );
  }
}
